import * as React from "react";
import { SVGProps } from "react";

const OnlineRegistrationBackIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`min-icon`}
    fill={"currentcolor"}
    viewBox="0 0 256 256"
    {...props}
  >
    <defs>
      <clipPath id="online-registration-back_svg__a">
        <path
          data-name="Rect\xE1ngulo 1600"
          fill="#2781b0"
          d="M0 0h256v199.269H0z"
        />
      </clipPath>
    </defs>
    <path data-name="Rect\xE1ngulo 1602" fill="none" d="M0 0h256v256H0z" />
    <g data-name="Grupo 2521">
      <g
        data-name="Grupo 2520"
        clipPath="url(#online-registration-back_svg__a)"
        fill="#2781b0"
        transform="translate(0 22.634)"
      >
        <path
          data-name="Trazado 7245"
          d="M110.325 123.433a78.259 78.259 0 0 0 .768 10.936h13.5v-21.871h-13.5a78.271 78.271 0 0 0-.768 10.936Z"
        />
        <path
          data-name="Trazado 7246"
          d="M112.411 105.696h12.187V85.56c-4.871 2.382-9.583 9.676-12.187 20.141"
        />
        <path
          data-name="Trazado 7247"
          d="M124.599 161.316v-20.141h-12.188c2.6 10.464 7.316 17.761 12.187 20.141"
        />
        <path
          data-name="Trazado 7248"
          d="M162.4 105.7a38.951 38.951 0 0 0-18.91-17.748 52.941 52.941 0 0 1 7.113 17.748Z"
        />
        <path
          data-name="Trazado 7249"
          d="M103.53 123.433a85.92 85.92 0 0 1 .711-10.937H90.854a38.2 38.2 0 0 0 0 21.873h13.384a86.293 86.293 0 0 1-.711-10.936"
        />
        <path
          data-name="Trazado 7250"
          d="M112.5 87.95a38.954 38.954 0 0 0-18.909 17.748h11.8a53.038 53.038 0 0 1 7.113-17.748"
        />
        <path
          data-name="Trazado 7251"
          d="M93.597 141.173a38.956 38.956 0 0 0 18.909 17.748 52.942 52.942 0 0 1-7.113-17.748Z"
        />
        <path
          data-name="Trazado 7252"
          d="M151.757 112.499a84.331 84.331 0 0 1 0 21.873h13.385a38.182 38.182 0 0 0 0-21.873Z"
        />
        <path
          data-name="Trazado 7253"
          d="M143.491 158.922a38.962 38.962 0 0 0 18.91-17.748h-11.8a52.968 52.968 0 0 1-7.113 17.748"
        />
        <path
          data-name="Trazado 7254"
          d="M192.789 69.359c.12-1.539.177-2.98.177-4.393a64.966 64.966 0 0 0-129.932 0c0 1.413.058 2.854.177 4.393a64.967 64.967 0 0 0 1.754 129.91h126.069a64.967 64.967 0 0 0 1.754-129.91Zm-21.947 69.376a3.373 3.373 0 0 1-.2.561 45.463 45.463 0 0 1-85.276 0 3.126 3.126 0 0 1-.2-.561 44.686 44.686 0 0 1 0-30.59 3.233 3.233 0 0 1 .2-.561 45.463 45.463 0 0 1 85.277 0 3.128 3.128 0 0 1 .2.561 44.711 44.711 0 0 1 0 30.59"
        />
        <path
          data-name="Trazado 7255"
          d="M131.398 141.173v20.141c4.871-2.38 9.583-9.677 12.187-20.141Z"
        />
        <path
          data-name="Trazado 7256"
          d="M131.398 85.557v20.141h12.187c-2.6-10.464-7.316-17.758-12.187-20.141"
        />
        <path
          data-name="Trazado 7257"
          d="M145.671 123.433a78.26 78.26 0 0 0-.769-10.937h-13.5v21.872h13.5a78.262 78.262 0 0 0 .769-10.936Z"
        />
      </g>
    </g>
  </svg>
);

export default OnlineRegistrationBackIcon;
